import React from 'react';  
import styles from '../../Routes.module.css';  
import manageStyles from './ManageTemplates.module.css';
import { Route, Routes } from 'react-router-dom';  
import AdminTemplateBankItems from './AdminTemplateBankItems';

const ManageTemplates = () => {  
  return (  
    <div className={`${styles.container} ${manageStyles.container}`}>  
      <div className={styles.header}>  
        <h3>Manage Templates</h3>  
      </div>  
      <div className={`${styles.body} ${manageStyles.body}`}>  
        <Routes>
          <Route path="active" element={<AdminTemplateBankItems/>} />
          <Route path="archive" element={<AdminTemplateBankItems/>} />
        </Routes>
      </div>  
    </div>  
  );  
};  
  
export default ManageTemplates;